// (perf3) ctx.font IS NOT A CHEAP ASSIGNMENT. Every set re-parses the
// shorthand and, on a connected <canvas>, resolves it against the element's
// computed style — which FORCES a synchronous style recalc whenever the
// document has pending style work (and during a glide it always does). A
// profile billed 345ms self to `set font` plus 331ms of Recalculate Style to
// the per-draw assignment in drawCanvas.
//
// Assign only when the context does not already hold this font. Keyed on
// what we last set AND the context's live value (the getter serialises the
// current state — no style work), so save()/restore(), a canvas resize
// (which resets state), or another writer changing the font all fall back
// to a real assignment. Never skips a font the context does not have.
export function setCtxFont(ctx, font) {
  if (ctx.__fontSet === font && ctx.font === ctx.__fontSeen) return
  ctx.font = font
  ctx.__fontSet = font
  ctx.__fontSeen = ctx.font
}
